var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.98 362.98",
    style: {
      enableBackground: "new 0 0 362.98 362.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A3CAB5;}\n\t.st1{fill:none;stroke:#A3CAB5;stroke-width:20;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#A3CAB5;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:15;}\n\t.st3{fill:#C8DFD3;}\n\t.st4{fill:none;stroke:#C8DFD3;stroke-width:20;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#B5D5C4;stroke-width:25;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#A3CAB5;stroke-width:25;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#DAEAE1;stroke-width:25;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.41,362.98h-0.01c-48.48-0.02-94.04-18.92-128.31-53.22C18.83,275.46-0.02,229.88,0,181.4 C0.05,81.36,81.46,0,181.49,0c0.03,0,0.06,0,0.09,0c48.44,0.02,93.99,18.9,128.24,53.16c34.25,34.25,53.13,79.8,53.16,128.24 c-0.03,48.5-18.93,94.08-53.21,128.37C275.48,344.05,229.9,362.95,181.41,362.98z M181.49,20C92.47,20,20.04,92.39,20,181.41 c-0.02,43.14,16.76,83.7,47.24,114.21c30.48,30.51,71.03,47.33,114.16,47.36c89.04-0.06,161.52-72.54,161.58-161.58 C342.94,92.45,270.53,20.04,181.57,20C181.55,20,181.51,20,181.49,20z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.9,138.14c-15.09-4.14-31.91-0.29-43.76,11.56c-17.57,17.57-17.57,46.07,0,63.64 c11.87,11.77,28.64,15.59,43.71,11.5C71.85,199.81,71.87,163.15,92.9,138.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.22,229.63c2.4,3.43,5.1,6.7,8.02,9.76c4.66-2.77,9.06-6.15,13.09-10.13c26.36-26.36,26.36-69.1,0-95.46 c-4.01-4.01-8.4-7.4-13.04-10.18c-2.77,2.91-5.36,6.01-7.67,9.25l-2.44-1.74c2.25-3.16,4.75-6.18,7.42-9.04 c-25.57-13.77-58.14-9.88-79.72,11.71c-1.4,1.4-2.71,2.86-3.97,4.35c7.28,2,14.16,5.84,19.88,11.56 c17.57,17.57,17.57,46.07,0,63.64c-5.75,5.69-12.64,9.52-19.93,11.5c1.27,1.51,2.6,2.99,4.02,4.41 c21.64,21.44,54.1,25.32,79.67,11.65c-2.82-3.01-5.43-6.21-7.78-9.55L171.22,229.63z M156.16,158.55c1.34-4.9,3.12-9.71,5.29-14.29 l2.71,1.29c-2.1,4.42-3.81,9.06-5.1,13.79L156.16,158.55z M153.39,188.78c-0.42-5.06-0.4-10.18,0.06-15.24l2.99,0.27 c-0.45,4.88-0.47,9.83-0.06,14.72L153.39,188.78z M161.15,218.14c-2.13-4.6-3.88-9.43-5.17-14.34l2.9-0.77 c1.25,4.75,2.93,9.4,4.99,13.84L161.15,218.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.72,97.79l-0.23-2.99c-5.07,0.38-10.13,1.21-15.04,2.47l0.74,2.91C223.94,98.96,228.83,98.16,233.72,97.79 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.05,220.05c2.25-4.54,4.1-9.32,5.52-14.2l-2.88-0.84c-1.37,4.71-3.16,9.32-5.33,13.71L318.05,220.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.27,113.47l1.76-2.43c-4.11-2.98-8.51-5.61-13.08-7.82l-1.31,2.7 C281.05,108.05,285.3,110.59,289.27,113.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.31,105.06l-1.24-2.73c-4.62,2.1-9.08,4.62-13.27,7.5l1.7,2.47C196.55,109.52,200.86,107.08,205.31,105.06 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.89,100.7l0.81-2.89c-4.88-1.37-9.92-2.33-14.97-2.83l-0.3,2.99C253.32,98.46,258.18,99.38,262.89,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.52,190.9c0.54-5.04,0.65-10.17,0.31-15.24l-2.99,0.2c0.33,4.89,0.23,9.84-0.3,14.71L326.52,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.64,248.62l-1.8,2.4c4.07,3.04,8.43,5.74,12.96,8.02l1.35-2.68C197.78,254.16,193.58,251.56,189.64,248.62 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.15,132.85c-2.83-4.19-6.07-8.16-9.61-11.82l-2.16,2.09c3.42,3.53,6.55,7.37,9.28,11.42L312.15,132.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.48,160.6c-1.22-4.94-2.88-9.79-4.94-14.42l-2.74,1.22c1.99,4.47,3.59,9.16,4.77,13.92L324.48,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.95,265.18l0.17,2.99c5.07-0.29,10.15-1.03,15.08-2.2l-0.69-2.92 C254.75,264.19,249.85,264.9,244.95,265.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.12,233.06l-2.41-1.78c-2.5,3.38-5.28,6.62-8.27,9.61c-0.48,0.48-0.97,0.95-1.46,1.42l2.06,2.18 c0.51-0.48,1.01-0.97,1.52-1.47C304.65,239.91,307.53,236.57,310.12,233.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.83,261.79l-0.86,2.87c4.86,1.45,9.88,2.49,14.92,3.07l0.35-2.98 C225.37,264.19,220.52,263.19,215.83,261.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.49,258.44l1.19,2.76c4.66-2.01,9.18-4.45,13.42-7.24l-1.65-2.5C282.35,254.15,277.99,256.5,273.49,258.44 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOne);
export default __webpack_public_path__ + "static/media/image_one.748fef89b8dd1b502c7524df8a768c45.svg";
export { ForwardRef as ReactComponent };